import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { CommonEdgeRaisedInputProp } from "../../../../../Type/CommonComponant";

const CommonEdgeInput = ({ inputType, label, placeholder,inputClass,rows }: CommonEdgeRaisedInputProp) => {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>{label}</Label>
          <Input className={`btn-pill ${inputClass}`} autoComplete="" type={inputType} placeholder={placeholder} rows={rows} />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default CommonEdgeInput;
